import React from 'react';
import { Sprout, UserPlus, Users, Home } from 'lucide-react';
import { Button, GardenBackground } from '../components/ui';
import RotaryLogo from '../assets/RotaryInternationLogo.png';

export const WelcomeScreen = ({ onNavigate }) => {
  return (
    <div className="min-h-screen relative flex items-center justify-center px-4 py-12">
      <GardenBackground />

      <div className="w-full max-w-sm relative z-10">
        {/* Logo & Title */}
        <div className="text-center mb-10">
          <img src="/logo.svg" alt="GrowthSprouts" className="w-20 h-20 mx-auto mb-3" />
          <h1 className="text-4xl mb-2" style={{ fontFamily: "'DM Serif Display', serif" }}>
            <span className="text-emerald-700">Growth</span>
            <span className="text-gray-800">Sprouts</span>
          </h1>
          <p className="text-base text-gray-500">
            Helping families grow their savings together
          </p>
        </div>

        {/* Main Actions */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 space-y-3">
          <Button
            size="lg"
            className="w-full"
            onClick={() => onNavigate('createFamily')}
          >
            <Home className="w-4 h-4 mr-2" />
            Create New Family
          </Button>

          <Button
            variant="secondary"
            size="lg"
            className="w-full"
            onClick={() => onNavigate('joinExistingFamily')}
          >
            <UserPlus className="w-4 h-4 mr-2" />
            Join Existing Family
          </Button>

          {/* Divider */}
          <div className="relative py-2">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-100" />
            </div>
            <div className="relative flex justify-center">
              <span className="bg-white px-3 text-xs text-gray-400">Already have an account?</span>
            </div>
          </div>

          {/* Login buttons */}
          <div className="grid grid-cols-2 gap-2">
            <Button
              variant="ghost"
              size="sm"
              className="w-full"
              onClick={() => onNavigate('guardianLogin')}
            >
              <Users className="w-3.5 h-3.5 mr-1.5" />
              Guardian
            </Button>

            <Button
              variant="ghost"
              size="sm"
              className="w-full"
              onClick={() => onNavigate('kidLogin')}
            >
              <Sprout className="w-3.5 h-3.5 mr-1.5" />
              Child
            </Button>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-gray-400 mt-6 leading-relaxed">
          Start a new family or join an existing one.
          <br />Kids can log in with their username and PIN.
        </p>
      </div>

      {/* Rotary Logo */}
      <div className="fixed bottom-4 right-4 z-20">
        <img
          src={RotaryLogo}
          alt="Rotary International"
          className="h-10 w-auto opacity-50 hover:opacity-80 transition-opacity cursor-pointer"
          onClick={() => window.open('https://www.rotary.org', '_blank')}
        />
      </div>
    </div>
  );
};